import {FormikErrors, yupToFormErrors} from 'formik';
import {isEmpty} from 'lodash';
import {StepConfig, StepPosition} from 'src/types/form';

export type ValidationResult<T> = Promise<FormikErrors<T> | object>;

export const VISITED_ELIGIBILITY = 'VISITED_ELIGIBILITY';

export async function validateStep<T, A>(
  step: StepConfig<T, A>,
  form: T,
  abortEarly = false
): ValidationResult<T> {
  let errors: object | FormikErrors<T> = {};

  if ('validate' in step) {
    // @ts-expect-error: formik type error
    errors = await step.validate(form);
  }

  if (!('schema' in step)) return errors;

  try {
    await step.schema.validate(form, {abortEarly: abortEarly});
  } catch (error: $TSFixMe) {
    if (error.name !== 'ValidationError') throw error;
    errors = yupToFormErrors(error);
  }

  return errors;
}

const visitedEligibility = window.localStorage.getItem(VISITED_ELIGIBILITY) === 'true';

export async function getInitialStep<T, A>(
  steps: StepConfig<T, A>[],
  form: T,
  hasEligibilityPage?: boolean
): Promise<StepPosition> {
  if (hasEligibilityPage && !visitedEligibility) {
    return {
      index: 0,
      key: steps[0].key,
    };
  }

  for (let index = 0; index < steps.length; index++) {
    const step = steps[index];
    const results = await validateStep(step, form, true);
    if (!isEmpty(results)) {
      console.log(`Sending to [${step.key}]`);
      return {
        index,
        key: step.key,
      };
    }
  }

  console.log('No invalid steps...returning to beginning');
  return {
    index: 0,
    key: steps[0].key,
  };
}

export async function filterSteps<Values, Actions>(
  getValues: () => Promise<Values> | Values,
  steps: StepConfig<Values, Actions>[]
): Promise<StepConfig<Values, Actions>[]> {
  const values = await getValues();
  return steps.reduce<StepConfig<Values, Actions>[]>((filteredSteps, step) => {
    if (!step.shouldDisplay) return filteredSteps.concat(step);
    return step.shouldDisplay && step.shouldDisplay(values)
      ? filteredSteps.concat(step)
      : filteredSteps;
  }, []);
}
